import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Holiday } from 'data/holiday/holiday.modle';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: Holiday[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<Holiday[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const holidaySlice = createSlice({
  name: 'holiday',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default holidaySlice;
